// Hide heavy rotation and sports network
export const PODCAST_IDS = [
  // "67noaIcDmS3fPnKyGeg4dp",
  // "3il0d30QvXpJvn5Rh3xW1c",
  "0PpILZeKTzVub4EjIlwMIz",
];

export const SPOTIFY_ID_TO_SLUG_MAPPING = {
  "67noaIcDmS3fPnKyGeg4dp": "kvrx-sports-network",
  "3il0d30QvXpJvn5Rh3xW1c": "heavy-rotation",
  "0PpILZeKTzVub4EjIlwMIz": "kvrx-exclusives",
};

export const SLUG_TO_SPOTIFY_ID_MAPPING = {
  "kvrx-sports-network": "67noaIcDmS3fPnKyGeg4dp",
  "heavy-rotation": "3il0d30QvXpJvn5Rh3xW1c",
  "kvrx-exclusives": "0PpILZeKTzVub4EjIlwMIz",
};

export const SPOTIFY_ID_TO_SHARE_LINKS = {
  "67noaIcDmS3fPnKyGeg4dp": {
    spotify: "https://open.spotify.com/show/67noaIcDmS3fPnKyGeg4dp",
    google:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8zYjkxYmU2MC9wb2RjYXN0L3Jzcw",
  },
  "3il0d30QvXpJvn5Rh3xW1c": {
    spotify: "https://open.spotify.com/show/3il0d30QvXpJvn5Rh3xW1c",
    google:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy80YTFiODc1NC9wb2RjYXN0L3Jzcw==",
    breaker: "https://www.breaker.audio/heavy-rotation-3",
    pocket: "https://pca.st/mfdxk8fo",
    radiopublic: "https://radiopublic.com/heavy-rotation-G2xm4v",
    rss: "https://anchor.fm/s/4a1b8754/podcast/rss",
  },
  "0PpILZeKTzVub4EjIlwMIz": {
    spotify: "https://open.spotify.com/show/0PpILZeKTzVub4EjIlwMIz",
    google:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8zZmU5NmFhOC9wb2RjYXN0L3Jzcw",
  },
};